"use strict";

exports.__esModule = true;
function extractPath(string) {
  var match = string.match(/^https?:\/\/[^\/]*/);

  if (match == null) return string;

  return string.substring(match[0].length);
}

exports["default"] = extractPath;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/history/lib/extractPath.js
// module id = 402
// module chunks = 0 1